<template>
  <CategoryForm
    v-if="instance"
    :value="instance"
    :breadcrumbs="breadcrumbs"
  >
    <template #actions="{form, fields, isEqual}">
      <VButtonDialog @confirm="remove(fields)">
        Delete
      </VButtonDialog>
      <v-btn
        :disabled="!form || isEqual"
        color="success"
        class="mx-2"
        rounded
        @click="update(fields)"
      >
        Save
      </v-btn>
    </template>
  </CategoryForm>
</template>

<script>
import CategoryForm from '@/pages/App/MenuCreator/Categories/__CategoryForm__'
import { Category } from '@/store/models'
import VButtonDialog from '@/components/VButtonDialog'
import removeMixin from '@/mixins/apiRemoveMixin'
import updateMixin from '@/mixins/apiUpdateMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'CategoryId',
  components: { CategoryForm, VButtonDialog },
  mixins: [removeMixin(Category), updateMixin(Category)],
  computed: {
    ...mapGetters('app', ['categories']),
    breadcrumbs () {
      return [
        {
          text: 'Categories',
          exact: true,
          to: { name: 'App-MenuCreator-Categories' }
        },
        {
          text: this.instance.name,
          exact: true,
          to: { name: 'App-MenuCreator-Categories-id', params: { id: this.instance.id } }
        }
      ]
    },
    instance () {
      const category = this.categories.find(this.$route.params.id)
      if (category?.categoryItems) {
        category.categoryItems.sort((x, y) => x.rank - y.rank)
      }
      return category
    }
  }
}
</script>
